import React from 'react'
import { PaginaType } from 'utils/types'
import { Breadcrumbs, WContainer } from '@components/atoms'
import { Page } from '@components/organisms'
import styles from './ComplianceTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'

interface Props {
  pagina: PaginaType
  withPlaceholder?: boolean
  defaultContent?: any
  children?: any
}

const ComplianceTemplate = (props: Props) => {
  const { pagina, withPlaceholder = true, defaultContent, children } = props

  return (
    <Page pagina={pagina} item={{}}>
      <WContainer>
        <div className={styles.breadcrumbs}>
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>
        <div className={styles.main}>
          <h1 className={styles.title}>{pagina.titolo}</h1>
          {!!pagina.descrizione && (
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
            />
          )}
          {withPlaceholder &&
            <PlaceholderReact
              contentTypeId={pagina.model}
              objectId={pagina.pk}
              pkey="content"
              serverSideContent={defaultContent}
            />
          }
          {children}
        </div>
      </WContainer>
    </Page>
  )
}

export default ComplianceTemplate
